import { SvgIcon } from "@mui/material";
import { trainwellColor } from "src/theme/themePrimitives";

export const TargetIcon = () => (
  <SvgIcon>
    {/* credit: cog icon from https://heroicons.com */}
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={0}
    >
      <path
        d="M12.1845 22.3691C17.8099 22.3691 22.3722 17.8068 22.3722 12.1845C22.3722 6.56226 17.8099 2 12.1845 2C6.56226 2 2 6.56226 2 12.1845C2 17.8068 6.56226 22.3691 12.1845 22.3691ZM12.1845 20.1313C7.79032 20.1313 4.23776 16.5787 4.23776 12.1845C4.23776 7.79032 7.79032 4.23776 12.1845 4.23776C16.5787 4.23776 20.1344 7.79032 20.1344 12.1845C20.1344 16.5787 16.5787 20.1313 12.1845 20.1313Z"
        fill={trainwellColor.success3}
      />
      <path
        d="M12.1841 18.323C15.5741 18.323 18.3196 15.5744 18.3196 12.1875C18.3196 8.8006 15.5741 6.052 12.1841 6.052C8.79725 6.052 6.05176 8.8006 6.05176 12.1875C6.05176 15.5744 8.79725 18.323 12.1841 18.323ZM12.1841 16.3533C9.88022 16.3533 8.01841 14.4946 8.01841 12.1875C8.01841 9.88046 9.88022 8.02176 12.1841 8.02176C14.4912 8.02176 16.353 9.88046 16.353 12.1875C16.353 14.4946 14.4912 16.3533 12.1841 16.3533Z"
        fill={trainwellColor.success3}
      />
      <path
        d="M12.1842 14.5489C13.4938 14.5489 14.552 13.4942 14.552 12.1811C14.552 10.8715 13.4938 9.81323 12.1842 9.81323C10.8778 9.81323 9.81641 10.8715 9.81641 12.1811C9.81641 13.4942 10.8778 14.5489 12.1842 14.5489Z"
        fill={trainwellColor.success3}
      />
    </svg>
  </SvgIcon>
);
